import {Map, Stack, Set} from 'immutable'
import * as types from '../ActionTypes.js'
import {getGracefullyMergedContainersMap} from "./ContainersReducer";

const initialState = {
    loading: false,

    questionnairesMap: Map(),
    error: undefined

}

const startLoading = (state, action) => {
    return {...state, loading: true, error: undefined}
}

const stopLoading = (state, action) => {
    return {...state, loading: false, error: action.error}
}

const QuestionnairesReducer = (state = initialState, action = {}) => {

    switch (action.type) {


        case types.CREATE_QUESTIONNAIRE:
        case types.UPDATE_QUESTIONNAIRE:
        case types.DELETE_QUESTIONNAIRE:
        case types.LOAD_QUESTIONNAIRES:
            return {
                ...state,
                loading: true,
                error: undefined
            }

        case types.CREATE_QUESTIONNAIRE_FAIL:
        case types.UPDATE_QUESTIONNAIRE_FAIL:
        case types.DELETE_QUESTIONNAIRE_FAIL:
        case types.LOAD_QUESTIONNAIRES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }

        case types.CREATE_QUESTIONNAIRE_SUCCESS:
        case types.UPDATE_QUESTIONNAIRE_SUCCESS:
            return {
                ...state,
                loading: false,
                questionnairesMap: getGracefullyMergedContainersMap(state.questionnairesMap, [action.questionnaire])
            }


        case types.DELETE_QUESTIONNAIRE_SUCCESS:
            return {
                ...state,
                loading: false,
                questionnairesMap: state.questionnairesMap.delete(action.id),
            }


        case types.LOAD_QUESTIONNAIRES_SUCCESS:
            return {
                ...state,
                loading: false,
                questionnairesMap: getGracefullyMergedContainersMap(state.questionnairesMap, action.questionnaires)
            }


        default:
            return state;
    }

}

export default QuestionnairesReducer;
